import { ModelSagres } from "@/types/model-sagres"


export class Autor extends ModelSagres {
    IdAutor: number
    NmAutor: string
    TipoAutor: string
    IdTipoAutor: number | null
    NrAnoInicioMandato: number
    NrAnoFimMandato: number

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.IdAutor) this.IdAutor = obj.IdAutor
            if (obj.NmAutor) this.NmAutor = obj.NmAutor
            if (obj.TipoAutor) this.TipoAutor = obj.TipoAutor
            if (obj.IdTipoAutor) this.IdTipoAutor = obj.IdTipoAutor
            if (obj.NrAnoInicioMandato) this.NrAnoInicioMandato = obj.NrAnoInicioMandato
            if (obj.NrAnoFimMandato) this.NrAnoFimMandato = obj.NrAnoFimMandato
        }
    }
}